import { render, staticRenderFns } from "./ColocarPlacaDialog.vue?vue&type=template&id=42120f2b&"
import script from "./ColocarPlacaDialog.vue?vue&type=script&lang=js&"
export * from "./ColocarPlacaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports